import { createSelector } from '@reduxjs/toolkit'
import { stageSizeSelector } from './stage_selectors.js'
import { getScrubberDisplayData } from './static_scrubber_display_selectors.js'
import { scrollerSelector } from './scroller_selectors.js'

// the position and size of the scrubber
export const scrubberBoundsSelector = createSelector(
  stageSizeSelector,
  getScrubberDisplayData,
  scrollerSelector,
  function (stageSize, scrubberDisplayData, scrollerData) {
    const margin = scrubberDisplayData.margin
    const height = scrubberDisplayData.height
    // Note: margin is an array [null, right, bottom, left]
    const x = margin[3]
    const y = stageSize.height - margin[2] - height
    const width = stageSize.width - margin[1] - margin[3]
    return { x, y, width, height }
  }
)

export const cursorSelector = createSelector(
  scrollerSelector,
  scrubberBoundsSelector,
  function (scrollerData, scrubberBounds) {
    const left = scrollerData.left
    const right = scrollerData.right
    const minWidthRatio = scrollerData.minWidthRatio
    const maxWidthRatio = scrollerData.maxWidthRatio
    const sizeRatio = right - left
    let canDragLeft, canDragRight

    // viewport cursor
    canDragLeft = left > 0
    canDragRight = right < 1
    const viewportCursor = canDragLeft || canDragRight ? 'move' : 'auto'
    /*
    console.log("Can drag left", canDragLeft)
    console.log("Can drag right", canDragRight)
    console.log("So viewport cursor is", viewportCursor)
    */

    // left handle cursor
    canDragLeft = left > 0 && sizeRatio < minWidthRatio
    canDragRight = sizeRatio > maxWidthRatio
    const leftHandleCursor = canDragLeft || canDragRight ? 'col-resize' : 'auto'
    //console.log("Can drag left handle to left", canDragLeft)
    //console.log("Can drag left handle to right", canDragRight)
    //console.log("So left handle cursor is", leftHandleCursor)

    // right handle cursor
    canDragLeft = sizeRatio > maxWidthRatio
    canDragRight = right < 1 && sizeRatio < minWidthRatio
    const rightHandleCursor = canDragLeft || canDragRight ? 'col-resize' : 'auto'
    //console.log("Can drag right handle to left", canDragLeft)
    //console.log("Can drag right handle to right", canDragRight)
    //console.log("So right handle cursor is", rightHandleCursor)

    return {
      leftHandle: leftHandleCursor,
      rightHandle: rightHandleCursor,
      viewport: viewportCursor,
      surface: 'auto',
    }
  }
)
